import cx from 'classnames'
import * as React from 'react'

import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Link from '../Link/Link'
import styles from './serviceMenuMobileLinks-style.css'
import HighlightCard from '@/components/HighlightCard/HighlightCard'
import { HighlightCardViewModel } from '@/view-models/HighlightCardViewModel'

type Props = {
  items?: LinkViewModel[]
  cardLinks?: HighlightCardViewModel[]
}
type State = {}

class ServiceMenuMobileLinks extends React.Component<Props, State> {
  static displayName = 'ServiceMenuMobileLinks'
  static defaultProps = {}

  renderItem(item: LinkViewModel) {
    return (
      <li key={item.href} className={styles.item}>
        <Link
          {...item}
          className={cx(styles.itemLink, {
            [styles.itemLinkActive]: item.active,
          })}

          hoverArrow
        >
          {item.label}
        </Link>
      </li>
    )
  }

  render() {
    const { items, cardLinks } = this.props

    if (!items && !cardLinks) {
      return null
    }

    return <ul className={styles.serviceMenuMobileLinks}>
      {items && items.map(this.renderItem)}
      {cardLinks && cardLinks.map((item) => (
          <HighlightCard item={item} />
      ))}
    </ul>
  }
}

export default ServiceMenuMobileLinks